import { _AppBaseStore, AppBaseStoreProps } from '@controladad/ng-base';
import { Injectable } from '@angular/core';

export interface AppPermission {
  id: number;
  key: string;
}

export interface AppStoreProps extends AppBaseStoreProps {
  shrinkSidebar?: boolean;
  allAppPermissions?: AppPermission[];
}

@Injectable({
  providedIn: 'root'
})
export class AppStore extends _AppBaseStore<AppStoreProps> {
  constructor() {
    super({
      shrinkSidebar: false,
    });
  }

  getAllPermissions() {
    return this.get().allAppPermissions ?? [];
  }

  setAllPermissions(keys: AppPermission[]) {
    this.patch({
      allAppPermissions: keys,
    });
  }
}
